/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import Swal from 'sweetalert2';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Autocomplete,
  TextField,
  Switch,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { DataGridPro } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { toast } from 'react-toastify';
// Context
import useEventCalendarContext from '../context/useEventCalendarContext';
// API
import { getUpdateCalendarEvent } from '../../../api/eventCalendarApi';

function UpdateEventModal() {
  const {
    addEventModalDefaultForm,
    updateEventModal,
    setUpdateEventModal,
    handleGenerateFilter,
    eventTypeOptions,
  } = useContext(useEventCalendarContext);

  const handleChangeFilter = (newValue, row, index, name) => {
    const newArr = [...updateEventModal.data];

    if (name === 'event_name') {
      newArr[index] = {
        id: row.id,
        date_from: moment(row?.date_from).format('YYYY-MM-DD'),
        date_to: moment(row?.date_to).format('YYYY-MM-DD'),
        name: newValue.target.value,
        event_type_id: row?.value,
        type: row?.label,
        event_type_selected: row?.event_type_selected,
        is_plottable: row?.is_plottable,
      };
    }

    if (name === 'is_plottable') {
      newArr[index] = {
        id: row.id,
        date_from: moment(row?.date_from).format('YYYY-MM-DD'),
        date_to: moment(row?.date_to).format('YYYY-MM-DD'),
        name: row?.name,
        event_type_id: row?.value,
        type: row?.label,
        event_type_selected: row?.event_type_selected,
        is_plottable: newValue.target.checked,
      };
    }

    if (name === 'date_from') {
      newArr[index] = {
        id: row.id,
        date_from: moment(newValue).format('YYYY-MM-DD'),
        date_to: moment(newValue).format('YYYY-MM-DD'),
        name: row?.name,
        event_type_id: row?.value,
        type: row?.label,
        event_type_selected: row?.event_type_selected,
        is_plottable: row?.is_plottable,
      };
    }

    if (name === 'date_to') {
      newArr[index] = {
        id: row.id,
        date_from: moment(row?.date_from).format('YYYY-MM-DD'),
        date_to: moment(newValue).format('YYYY-MM-DD'),
        name: row?.name,
        event_type_id: row?.value,
        type: row?.label,
        event_type_selected: row?.event_type_selected,
        is_plottable: row?.is_plottable,
      };
    }

    setUpdateEventModal({ ...updateEventModal, data: newArr });
  };

  const handleChangeDropdown = (newValue, row, index) => {
    const newArr = [...updateEventModal.data];

    newArr[index] = {
      id: row.id,
      date_from: moment(row?.date_from).format('YYYY-MM-DD'),
      date_to: moment(row?.date_to).format('YYYY-MM-DD'),
      name: row?.name,
      event_type_id: newValue?.value,
      type: newValue?.label,
      event_type_selected: newValue,
      is_plottable: row?.is_plottable,
    };

    setUpdateEventModal({ ...updateEventModal, data: newArr });
  };

  const columns = [
    {
      field: 'date_from',
      headerName: 'Date From',
      width: 200,
      renderCell: (params) => (
        <div>
          <DatePicker
            views={['month', 'day', 'year']}
            value={params?.row?.date_from}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <TextField {...param} />
            )}
            onChange={(newValue) =>
              handleChangeFilter(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
                'date_from',
              )
            }
          />
        </div>
      ),
    },
    {
      field: 'date_to',
      headerName: 'Date To',
      width: 200,
      renderCell: (params) => (
        <div>
          <DatePicker
            views={['month', 'day', 'year']}
            value={params?.row?.date_to}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
              <TextField {...param} />
            )}
            onChange={(newValue) =>
              handleChangeFilter(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
                'date_to',
              )
            }
            readOnly
          />
        </div>
      ),
    },
    {
      field: 'name',
      headerName: 'Event Name',
      width: 400,
      renderCell: (params) => (
        <TextField
          id='outlined-basic'
          variant='outlined'
          name='event_name'
          value={params?.row?.name}
          onKeyDown={(e) => {
            if (e.key === ' ' && e.stopPropagation());
          }}
          onChange={(e, newValue) =>
            handleChangeFilter(e, params.row, params.api.getRowIndex(params.row.id), 'event_name')
          }
          fullWidth
          placeholder='Event Name'
        />
      ),
    },
    {
      field: 'is_plottable',
      headerName: 'Plottable',
      width: 200,
      align: 'center',
      renderCell: (params) => (
        <div>
          <Switch
            defaultChecked
            size='small'
            color='success'
            sx={{ transform: 'scale(1.5)' }}
            checked={params?.row?.is_plottable}
            onChange={(e, newValue) =>
              handleChangeFilter(
                e,
                params.row,
                params.api.getRowIndex(params.row.id),
                'is_plottable',
              )
            }
          />
        </div>
      ),
    },
    {
      field: 'event_type',
      headerName: 'Type',
      width: 300,
      renderCell: (params) => (
        <div>
          <Autocomplete
            disablePortal
            id='event_type'
            disableClearable
            options={eventTypeOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => <TextField {...param} />}
            value={params?.row?.event_type_selected}
            onChange={(e, newValue) =>
              handleChangeDropdown(newValue, params.row, params.api.getRowIndex(params.row.id))
            }
            sx={{ backgroundColor: '#fff', width: '345%' }}
            required
          />
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setUpdateEventModal(addEventModalDefaultForm);
  };

  const handleUpdateEvent = async () => {
    try {
      toast.loading('Processing request please kindly wait...');

      const request = {
        datas: updateEventModal.data.map((row) => ({
          id: row.id,
          date: row.date_from,
          name: row.name,
          type: row.event_type_selected.value,
          is_plottable: row.is_plottable ? 1 : 0,
          is_enabled: 0,
        })),
      };

      const response = await getUpdateCalendarEvent(request);
      const { code, message } = response.data.response;

      if (code === '00004') {
        toast.success(message);
        setUpdateEventModal(addEventModalDefaultForm);
        handleGenerateFilter();
      }

      if (code === '500') {
        Swal.fire({
          title: 'Invalid Request',
          html: response?.data?.response?.result.join('<br />'),
          icon: 'warning',
        });
      }

      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Dialog onClose={handleClose} open={updateEventModal.toggle} fullWidth maxWidth='xl'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        View Event
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div style={{ marginBottom: 3, height: '550px', position: 'relative' }}>
          <DataGridPro
            rows={updateEventModal.data}
            columns={columns}
            sx={{
              '& .MuiDataGrid-cell': {
                padding: 0,
              },
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='success' onClick={handleUpdateEvent}>
          Submit
        </Button>

        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateEventModal;
